import { TapEncryptedFrame } from '@iotize/tap/client/api';

export function createTapEncryptedFrame(
  id: number,
  payload: Uint8Array,
  paddingGenerator?: (size: number) => Uint8Array,
): TapEncryptedFrame {
  const len = payload.length;
  // let padSize = computePadding(8 + len, 16)
  // let padding = paddingGenerator ? paddingGenerator(padSize) : undefined
  return {
    id,
    len,
    payload,

    // padding: padding
  };
}
